import React from 'react';
import style from './Body.css';

const MyCode = () => {
    return (
        <div className={style.bodyOuterDiv}>
            <img
            src='/assets/resume2022.png'
            alt='casey warrens resume' />
        </div>
    )
}

export default MyCode;
